import { Resume, SingleTemplateSettings } from '@rio/types'
import { useTemplateCustomization } from 'builder/components/DocumentCustomizationModal'

import { FontSize } from './FontSize/FontSize'
import { FontWeight } from './FontWeight/FontWeight'
import { FontSelection } from './FontSelection/FontSelection'

import * as Styled from './styles'

type Props = {
  resume: Resume
}

export const TextContent = ({ resume }: Props) => {
  const { currentTemplate, resumeSpecificTemplateSettings, supportsNewCustomization } =
    useTemplateCustomization(resume)

  return (
    <Styled.Container>
      <FontSelection resume={resume} supportsNewCustomization={supportsNewCustomization} />
      <FontSize resume={resume} currentTemplate={currentTemplate} />
      <FontWeight
        resume={resume}
        currentTemplate={currentTemplate}
        resumeSpecificTemplateSettings={resumeSpecificTemplateSettings as SingleTemplateSettings}
      />
    </Styled.Container>
  )
}
